import { computed, ErrorHandler, Injectable, inject, resource, type Signal } from '@angular/core';
import {
  ChannelDataStartRepository,
  type ChannelDataStarts,
} from './channel-data-start-repository';

const NONE: ChannelDataStarts = new Map();

/** The declared channel data starts, read once for the portal's life. */
@Injectable()
export class ChannelDataStartStore {
  private readonly repository = inject(ChannelDataStartRepository);
  private readonly errorHandler = inject(ErrorHandler);

  private readonly read: Promise<ChannelDataStarts> = this.repository.load();

  private readonly _resource = resource<ChannelDataStarts, undefined>({
    loader: async () => {
      try {
        return await this.read;
      } catch (cause: unknown) {
        this.errorHandler.handleError(cause);
        throw cause;
      }
    },
  });

  /** Empty until the read lands and after a failed read: a chart then fades nothing. */
  readonly starts: Signal<ChannelDataStarts> = computed(() =>
    this._resource.hasValue() ? this._resource.value() : NONE
  );

  /**
   * The same read for a loader that must not run ahead of it. A failed read resolves to the empty
   * map, which `starts` also answers; the resource above has reported it.
   */
  readonly whenLoaded: Promise<ChannelDataStarts> = this.read.catch((): ChannelDataStarts => NONE);
}
